import React, { useState } from "react";
import { EnvironmentOutlined, CalendarOutlined } from "@ant-design/icons";
import { List, Pagination } from "antd";

const pageSize = 6

function News({ leftNewsMsg, rightNewsMsg }) {
  const [currentPage, setCurrentPage] = useState(1);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;

  return (
    <div className="w-4/5 h-[600px] flex">
      <div className="mr-12 bg-slate-100 rounded-md w-[600px]">
        <div className="overflow-hidden rounded-t-md max-h-[350px] cursor-pointer">
          <img
            src={leftNewsMsg.img}
            alt="news img"
            className="hover:scale-110 transition-all duration-500 mb-6"
          />
        </div>
        <div className='flex flex-col gap-y-2 mt-2 px-3'>
          <h5 className="text-lg font-bold">{leftNewsMsg.title}</h5>
          <div className="flex space-x-4">
            <span className="flex justify-center space-x-2">
              <span className="flex items-center"><EnvironmentOutlined /></span>
              <span>{leftNewsMsg.location}</span>
            </span>
            <span className="flex justify-center space-x-2">
              <span className="flex items-center"><CalendarOutlined /></span>
              <span>{leftNewsMsg.date}</span>
            </span>
          </div>
          <div className="min-h-[100px] px-2 py-1 leading-6">
            <p>{leftNewsMsg.content}</p>
          </div>
        </div>
      </div>
      <div className="w-[600px] h-[600px] relative bg-slate-100 rounded-md px-4 py-2">
        <List
          className="w-full"
          dataSource={rightNewsMsg.slice(startIndex, endIndex)}
          renderItem={(item) => {
            const { title, time, link } = item
            let url = ''
            let content = (
              <span className="text-sm leading-5 cursor-pointer">
                {title}
              </span>
            )
            if (link !== '') {
              url = link?.startsWith("https") ? link : 'https://' + link
              content = (
                <a href={url} target="_blank">
                  <span className="text-sm leading-5">
                    {title}
                  </span>
                </a>
              )
            }
            return (
              <List.Item>
                <List.Item.Meta
                  title={content}
                  description={time}
                />
              </List.Item>
            )
          }}
        />
        {
          pageSize > 6 && <div className="absolute right-2 bottom-2 px-4">
            <Pagination
              total={rightNewsMsg.length}
              current={currentPage}
              pageSize={pageSize}
              onChange={handlePageChange}
            />
          </div>
        }
      </div>
    </div>
  );
}

export default News;
